import { bindActionCreators } from '@reduxjs/toolkit';
import { space } from 'folio-common-components';
import * as React from 'react';
import { connect } from 'react-redux';
import { Labels } from '../../messages';
import type { Dispatch, RootState } from '../../state';
import { newPerson, selectors, thunks } from '../../state/editor';
import { isValidPnum } from '../../utils/validators';
import { EditItem } from '../OwnerList/EditItem';
import { PersonInput } from '../PersonInput';
import { Box, BoxHeading } from '../box';
import { Button, TextButton } from '../buttons';

type PersonWithRolesAndOwnership = ReturnType<
  typeof selectors.peopleWithRolesAndOwnership
>[number];

interface Props {
  personId?: string;
  person: PersonWithRolesAndOwnership;
  onDone: () => any;
  onSavePerson: (person: PersonWithRolesAndOwnership) => any;
  editType: 'edit' | 'new';
}

interface State {
  person: PersonWithRolesAndOwnership;
  hasClickedSave: boolean;
}

class BaseChairForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const person =
      props.person ||
      Object.assign(newPerson(), {
        shares: 0,
        roles: ['chair'],
      });

    this.state = {
      person,
      hasClickedSave: false,
    };
  }

  save = () => {
    this.props.onSavePerson(this.state.person);
    this.props.onDone();
  };

  render() {
    const { editType, onDone } = this.props;
    const { person, hasClickedSave } = this.state;
    const isNew = editType === 'new';
    return (
      <EditItem>
        <BoxHeading>
          {isNew ? 'Hvem skal være styreleder?' : 'Endre detaljer'}
        </BoxHeading>

        {isNew ? (
          <p>
            Fastsetter dagsorden for styremøter og sørger for at den følges.
            Dobbeltstemme ved stemmelikhet.
          </p>
        ) : null}

        <Box>
          <form
            noValidate={true}
            onSubmit={evt => {
              evt.preventDefault();
            }}
            data-testid="RolePersonForm"
          >
            <PersonInput
              inputs={['autoName', 'pNum', 'email', 'phone']}
              disableAutocomplete={true}
              person={person}
              onChange={p => {
                this.setState(() => ({ person: { ...person, ...p } }));
              }}
              validate={hasClickedSave}
              editType={editType}
            />
          </form>

          <div css={space([48], 'margin-top')}>
            <Button
              onClick={() => {
                this.setState({ hasClickedSave: true });
                if (!isValidPnum(person.pNum)) {
                  return;
                }

                this.save();
              }}
              css={space([24], 'margin-right')}
            >
              <Labels.Done />
            </Button>{' '}
            <TextButton onClick={onDone}>
              <Labels.Cancel />
            </TextButton>
          </div>
        </Box>
      </EditItem>
    );
  }
}

function mapStateToProps(state: RootState, props: { personId?: string }) {
  const users = selectors.peopleWithRolesAndOwnership(state);
  const user = users.find(e => e.id === props.personId);

  return {
    person: user,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      onSavePerson: thunks.updateRolePerson,
    },
    dispatch,
  );
}

export const ChairForm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BaseChairForm);
